import Button from "@material-ui/core/Button";
import { forwardRef } from "react";
import styled from "styled-components";
import { CircularProgress } from "@material-ui/core";

const StyledSecondaryButton = styled(Button)`
  &.MuiButton-root {
    background: transparent;
    color: #2563eb;
    font-size: 13px;
    border-radius: 8px;
    height: 40px;
    font-weight: 800;
    border: 1px solid #2563eb;
    text-transform: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 10px;
    &:hover {
      background: #f8fbff;
    }
    &.Mui-disabled {
      color: #7f7f7f;
      border-color: #d1d1d1;
      background: transparent;
      cursor: not-allowed;
      &:hover {
        background: transparent;
      }
    }
  }
`;

const OutlineButton = forwardRef(
  ({ children, showIcon, disabled, loading, ...rest }, ref) => {
    return (
      <StyledSecondaryButton ref={ref} disabled={disabled} {...rest}>
        {loading && (
          <CircularProgress size={20} style={{ marginRight: "5px" }} />
        )}
        {children}
      </StyledSecondaryButton>
    );
  },
);

export default OutlineButton;
